export const disableBodyScroll = () => {
  document.body.classList.add('noscroll')
}

export const enableBodyScroll = () => {
  document.body.classList.remove('noscroll')
}

export const displayNone = (noneClassName) => {
  const el = document.querySelector(noneClassName)
  if (el !== null) {
    el.classList.add('displayNone')
  }
}

export const removeNone = (noneClassName) => {
  const el = document.querySelector(noneClassName)
  if (el !== null) {
    el.classList.remove('displayNone')
  }
}

export const disableBodyScrollKeepPosition = () => {
  document.body.classList.add('noscroll-keep-scroll-position')
  const myPooqContentBody = document.querySelector('.my-pooq-content-body')
  if (myPooqContentBody !== null) {
    myPooqContentBody.classList.add('noscroll-keep-scroll-position')
  }
}
export const enableBodyScrollKeepPosition = () => {
  const myPooqContentBody = document.querySelector('.my-pooq-content-body')
  if (myPooqContentBody !== null) {
    myPooqContentBody.classList.remove('noscroll-keep-scroll-position')
  }
  document.body.classList.remove('noscroll-keep-scroll-position')
}

export const categorySearchNeedLogin = () => {
  document.body.classList.add('needlogin')
}

export const categorySearchNeedlessLogin = () => {
  document.body.classList.remove('needlogin')
}

export const popupInsideThePlayerOpen = () => {
  document.body.classList.add('popup-inside-the-player')
}

export const popupInsideThePlayerClose = () => {
  document.body.classList.remove('popup-inside-the-player')
}
